import { useEffect, useState } from "react";
import Home from './bizHome';
import BeamioOnboardingModal from './LoadingPage'
import { useDaemonContext } from "@/providers/DaemonProvider"
import { checkStorage, isStandalone } from '@/services/beamio'
import SplashScreen from "@/components/SplashScreen"
import { refreshManifestThen } from '@/utils/updateManifestStartUrl'

const HomePage = ({}) => {
	const { isInitialLoading, setIsInitialLoading, setBeamio, setProfiles, beamio } = useDaemonContext()
	const [showBeamioOnboardingModal, setShowBeamioOnboardingModal] = useState(false)
	const [splashVisible, setSplashVisible] = useState(true)
	const [showInstallSheet, setShowInstallSheet] = useState(false)
	const init = async () => {
		const CoNETData: encrypt_keys_object = await checkStorage()
		if (CoNETData && CoNETData?.beamio?.initialLoading) {
			setSplashVisible(false)
			return
		}
		// 无账户时也要隐藏 splash，让用户看到 Create/Restore 入口
		setSplashVisible(false)
		setIsInitialLoading(true)
		setShowBeamioOnboardingModal(true)
	}

	useEffect(() => {
		init()
  	}, [])

	// 首次进入 Home 时显示 Install Web App 引导（非 PWA、未见过）
	useEffect(() => {
		if (showBeamioOnboardingModal || splashVisible) return
		const t = setTimeout(() => {
			refreshManifestThen(() => setShowInstallSheet(true))
		}, 600)
		return () => clearTimeout(t)
	}, [showBeamioOnboardingModal, splashVisible])
	
	const beamioTag = typeof window !== 'undefined' ? (new URLSearchParams(window.location.search).get('beamioTag') || '') : ''

	return (
		<div className="w-full h-full">
			{splashVisible && <SplashScreen />}
			{showBeamioOnboardingModal ? (
				<BeamioOnboardingModal
					home={() => {
						setShowBeamioOnboardingModal(false)
						setSplashVisible(false)
						setIsInitialLoading(false)
					}}
					onInitComplete={() => setSplashVisible(false)}
				/>
			) : (
				<Home />
			)}
		</div>
	)
}

export default HomePage

